import Autorizaciones_compras from "../../../views/administrador/Autorizaciones/Autorizaciones_compras";
import Autorizaciones_comprasV2 from "../../../views/administrador/Autorizaciones/Autorizaciones_comprasv2";




const routes_autorizaciones = [
  {
    path: "/Autorizaciones_compras",
    name: "Autorizaciones Compras",
    icon: "",
    component: Autorizaciones_compras,
    doNotShow: true,
  },
  {
    path: "/Autorizaciones_comprasV2",
    name: "Autorizaciones Compras V2",
    icon: "",
    component: Autorizaciones_comprasV2,
    doNotShow: true,
  },
 
];

export default routes_autorizaciones;
